// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__3ZRkz","list-dark":"list_list-dark__2qn9W"};